import React from 'react';
import StyledLink from './styles/StyledLink';

const Link =  ({ title, to, children, ...props }) => (<StyledLink
    title={title}
    href={to || '#'} {...props}
>{children}</StyledLink>);

export default Link;




// WEBPACK FOOTER //
// ./src/components/Link.js